module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "item"
  }, [_c('li', {
    staticClass: "gray"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("标题：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data.title))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("发件人：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.formatff(_vm.data.type)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("发送时间：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.created_at * 1000)))])]), _vm._v(" "), _c('li', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.data.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adc78d9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/item.vue
// module id = 641
// module chunks = 31